/**
 * Auth store (Zustand) — persistenza tokens + user.
 * Sincronizzato con localStorage per sopravvivere ai refresh pagina.
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface LegaBreve {
  id: string;
  nome: string;
  slug: string;
}

export interface User {
  id: string;
  email: string;
  nome_completo: string;
  ruolo_lega: string;
  ruoli_aggiuntivi: string[] | null;
  is_fondatore: boolean;
  /** Amministratore dell'app: dati comuni a tutte le leghe (29/09) */
  is_admin_app?: boolean;
  avatar_data_url?: string | null;
  /** scelte del generatore avatar (per riaprirlo com'era) */
  avatar_config?: Record<string, unknown> | null;
  /** lingua dell'app: "it" | "en" (2026-10-09) */
  lingua?: string;
  attivo: boolean;
  deve_cambiare_password: boolean;
  discord_user_id: string | null;
  preferenze_notifiche: Record<string, unknown>;
  created_at: string;
  updated_at: string;
  // Multi-lega: ruoli e lega si riferiscono alla lega corrente
  lega_corrente?: LegaBreve | null;
  n_leghe?: number;
  /** admin dell'app dentro una lega di cui non e' membro (monitor leghe) */
  in_supervisione?: boolean;
  /** Andrea 2026-10-10: la lega da cui si parte aprendo l'app */
  lega_preferita_id?: string | null;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  // Lega scelta esplicitamente (header X-Lega-Id); null = lega di default
  legaId: string | null;
  isAuthenticated: () => boolean;
  setTokens: (access: string, refresh: string) => void;
  setUser: (user: User | null) => void;
  setLegaId: (id: string | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      legaId: null,
      isAuthenticated: () => !!get().accessToken,
      setTokens: (access, refresh) => set({ accessToken: access, refreshToken: refresh }),
      setUser: (user) => set({ user }),
      setLegaId: (legaId) => set({ legaId }),
      clear: () => set({ accessToken: null, refreshToken: null, user: null, legaId: null }),
    }),
    {
      name: "fantasquad-auth",
      // user non viene persistito perché ricariciato da /auth/me al boot
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        legaId: state.legaId,
      }),
    },
  ),
);
